import React, { Fragment } from "react";

import { List, ListItemIcon, ListItemText, Divider, Collapse, ListItemButton } from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";

const classes = {
    listItem: {
        "&.MuiButtonBase-root": {
            padding: "8px 16px",
            width: "100%",
            "& .MuiListItemIcon-root": {
                minWidth: "40px",
            },
        },
    },
    selectedListItemText: {
        paddingLeft: "2px",
        fontSize: "1rem",
        color: "#000",
    },
    unselectedListItemText: {
        paddingLeft: "2px",
        fontSize: "1rem",
        color: "rgba(0, 0, 0, 0.54)",
    },
    sidebarIsOpen: {
        paddingLeft: "25px",
        transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
    },
    sidebarIsClosed: {
        paddingLeft: "0",
        transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
    },
};

const SubMenu = ({ handleToggle, sidebarIsOpen, isOpen, name, icon, children }) => (
    <Fragment>
        <ListItemButton onClick={handleToggle} sx={classes.listItem}>
            <ListItemIcon>{isOpen ? <ExpandMore /> : icon}</ListItemIcon>
            <ListItemText
                disableTypography
                inset
                primary={name}
                sx={isOpen ? classes.selectedListItemText : classes.unselectedListItemText}
            />
        </ListItemButton>
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding sx={sidebarIsOpen ? classes.sidebarIsOpen : classes.sidebarIsClosed}>
                {children}
            </List>
            <Divider />
        </Collapse>
        {!isOpen && <div></div>}
    </Fragment>
);

export default SubMenu;
